const roleMap = {
  [-1]: '患者',
  0: '系统',
  1: '患者',
  2: '医生',
  3: 'BD',
  4: '医生助手',
  5: '合作医院',
  6: 'cms',
  7: '医生学生',
  8: '财务人员'
}
export { roleMap }
// 1患者、2医生、3销售bd、4医生助手
export const roleEm = {
  1: '患者',
  2: '医生',
  3: 'BD',
  4: '健管'
}
export const directionEm = {
  0: '接听',
  1: '呼出'
}
